import { Fragment } from "react";
import "./BlockchainDevelopment.css";
import { blockchainDevelopment } from "../../staticdata";
import blockchaindevbanner from "../../assets/images/services/blockchain/blockchaindevbanner.png";

const BlockchainDevelopment = () => { 
  return (
    <Fragment>
      <section className="blockchaindev-style">
        <div className="blockchaindev-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="blockchaindev-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Blockchain Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Kairaa simplify blockchain for enterprises - delivering
                  secure, scalable, and ROI-driven solutions that solve real
                  business challenges. The best blockchain development company
                  for secure, scalable, and future-ready solutions. Our
                  expert-driven approach ensures seamless execution for your
                  ultimate business success.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={blockchaindevbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="blockchaindev-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Blockchain Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {blockchainDevelopment.map((services, index) => (
                <div className="col-lg-4 col-md-6" key={services.id} data-aos="zoom-in">
                  <div className="blockchain-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default BlockchainDevelopment;
